import { ListTree } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface SubtaskCountBadgeProps {
  count: number;
  className?: string;
}

/**
 * Compact "{n} subtasks" indicator. Used today on the task detail's
 * Subtasks header; ships ahead of slice 4 because the board view will
 * render this on parent cards (per `app/PRODUCT.md` §5).
 *
 * Renders nothing when count is 0 — call sites can drop the conditional.
 */
export const SubtaskCountBadge = ({ count, className }: SubtaskCountBadgeProps) => {
  if (count <= 0) return null;
  return (
    <span
      className={cn(
        'text-muted-foreground bg-muted/60 inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-xs font-medium',
        className,
      )}
      aria-label={`${count} subtask${count === 1 ? '' : 's'}`}
    >
      <ListTree className="size-3" aria-hidden="true" />
      {count}
    </span>
  );
};
